import { takeLatest } from "redux-saga/effects";
import { apis } from "../../config/APIs";
import { sagaFunctions } from "../../utils";

import {
  AddUserAdvance,
  UpdateUserAdvance,
  Advances,
  AdvancesApprove,
  AdvancesComments,
  AdvancesCommentsAdd,
  AdvancesDetailPDF,
  AdvancesExpAddComments,
  AdvancesExpComments,
  AdvancesExpDetails,
  AdvancesExpHistory,
  AdvancesExportExcel,
  AdvancesHistory,
  AdvancesReject,
  TransactionsPartialApprove,
  TransactionsReject,
  UserAdvanceFields,
  UserAdvances,
  UserAdvancesSubmit,
  UserAdvanceDelete,
  AdvanceShow,
} from "./advances";

function getAdvances(req) {
  return sagaFunctions(Advances, "get", apis.advances, req.payload, {
    skipSuccessMessage: true,
  })();
}

function getAdvanceShow(req) {
  return sagaFunctions(AdvanceShow, "get", apis.advanceShow, req.payload, {
    skipSuccessMessage: true,
  })();
}

function getAdvancesReject(req) {
  return sagaFunctions(
    AdvancesReject,
    "post",
    apis.advancesReject,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getTransactionsReject(req) {
  return sagaFunctions(
    TransactionsReject,
    "post",
    apis.transactionsReject,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getTransactionsPartialApprove(req) {
  return sagaFunctions(
    TransactionsPartialApprove,
    "post",
    apis.transactionsPartialApprove,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getAdvancesApprove(req) {
  return sagaFunctions(
    AdvancesApprove,
    "post",
    apis.advancesApprove,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getAdvancesExpDetails(req) {
  return sagaFunctions(
    AdvancesExpDetails,
    "get",
    apis.advanceShow,
    req.payload,
    { skipSuccessMessage: true },
  )();
}

function getAdvancesExpComments(req) {
  return sagaFunctions(
    AdvancesExpComments,
    "get",
    apis.getAdvanceTransactionComments,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getAdvancesExpAddComments(req) {
  return sagaFunctions(
    AdvancesExpAddComments,
    "post",
    apis.getAdvanceTransactionComments,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getAdvancesComments(req) {
  return sagaFunctions(
    AdvancesComments,
    "get",
    req.otherParams?.is_admin
      ? apis.advancesComments
      : apis.userAdvancesComments,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function getAdvancesCommentsAdd(req) {
  return sagaFunctions(
    AdvancesCommentsAdd,
    "post",
    req.otherParams?.is_admin
      ? apis.advancesComments
      : apis.userAdvancesComments,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getAdvancesExportExcel(req) {
  return sagaFunctions(
    AdvancesExportExcel,
    "post",
    apis.advancesExportExcel,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getAdvancesHistory(req) {
  return sagaFunctions(
    AdvancesHistory,
    "get",
    req.otherParams?.is_admin ? apis.advancesHistory : apis.userAdvancesHistory,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function getAdvancesExpHistory(req) {
  return sagaFunctions(
    AdvancesExpHistory,
    "get",
    apis.transactionsHistory,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function getUserAdvances(req) {
  return sagaFunctions(UserAdvances, "get", apis.userAdvances, req.payload, {
    skipSuccessMessage: true,
  })();
}

function advance_pdf(req) {
  return sagaFunctions(
    AdvancesDetailPDF,
    "get",
    apis.export_advance_details,
    req.payload,
    { skipSuccessMessage: true },
  )();
}

function getUserAdvancesSubmit(req) {
  const isRecall = req.payload.isRecall;
  delete req.payload.isRecall;
  return sagaFunctions(
    UserAdvancesSubmit,
    "post",
    isRecall ? apis.userAdvancesRecall : apis.userAdvancesSubmit,
    req.payload,
    {
      "Content-Type": isRecall ? "application/json" : "multipart/formdata",
    },
  )();
}

function getAddUserAdvance(req) {
  let formData = new FormData();
  req.payload?.field_values?.forEach((ele, i) => {
    formData.append(`field_values[${i}].id`, ele.id);
    formData.append(`field_values[${i}].value`, ele.value);
  });
  return sagaFunctions(AddUserAdvance, "post", apis.userAdvances, formData, {
    "Content-Type": "multipart/formdata",
  })();
}

function getUpdateUserAdvance(req) {
  // let formData = new FormData()
  // req.payload?.field_values?.forEach((ele, i) => {
  //   formData.append(`field_values[${i}][id]`, ele.id)
  //   formData.append(`field_values[${i}][value]`, ele.value)
  // })
  return sagaFunctions(
    UpdateUserAdvance,
    "post",
    apis.updateUserAdvances + "?id=" + req.payload?.id,
    req.payload,
  )();
}

function getUserAdvanceFields(req) {
  return sagaFunctions(
    UserAdvanceFields,
    "get",
    apis.userAdvanceFields,
    req.payload,
    {
      headers: {
        "Content-Type": "multipart/formdata",
      },
      skipSuccessMessage: true,
    },
  )();
}

function getUserAdvanceDelete(req) {
  return sagaFunctions(
    UserAdvanceDelete,
    "post",
    apis.userAdvanceDelete,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

export function* advancesWatcher() {
  yield takeLatest(Advances.REQUEST, getAdvances);
  yield takeLatest(AdvancesDetailPDF.REQUEST, advance_pdf);
  yield takeLatest(AdvancesReject.REQUEST, getAdvancesReject);
  yield takeLatest(TransactionsReject.REQUEST, getTransactionsReject);
  yield takeLatest(
    TransactionsPartialApprove.REQUEST,
    getTransactionsPartialApprove,
  );
  yield takeLatest(AdvancesApprove.REQUEST, getAdvancesApprove);
  yield takeLatest(AdvanceShow.REQUEST, getAdvanceShow);
  yield takeLatest(AdvancesExpDetails.REQUEST, getAdvancesExpDetails);
  yield takeLatest(AdvancesExpComments.REQUEST, getAdvancesExpComments);
  yield takeLatest(AdvancesExpAddComments.REQUEST, getAdvancesExpAddComments);
  yield takeLatest(AdvancesComments.REQUEST, getAdvancesComments);
  yield takeLatest(AdvancesCommentsAdd.REQUEST, getAdvancesCommentsAdd);
  yield takeLatest(AdvancesExportExcel.REQUEST, getAdvancesExportExcel);
  yield takeLatest(AdvancesHistory.REQUEST, getAdvancesHistory);
  yield takeLatest(AdvancesExpHistory.REQUEST, getAdvancesExpHistory);
  yield takeLatest(UserAdvances.REQUEST, getUserAdvances);
  yield takeLatest(UserAdvancesSubmit.REQUEST, getUserAdvancesSubmit);
  yield takeLatest(AddUserAdvance.REQUEST, getAddUserAdvance);
  yield takeLatest(UpdateUserAdvance.REQUEST, getUpdateUserAdvance);
  yield takeLatest(UserAdvanceFields.REQUEST, getUserAdvanceFields);
  yield takeLatest(UserAdvanceDelete.REQUEST, getUserAdvanceDelete);
}
